import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Card,
  TextField,
  Button,
  Alert,
  Typography,
  Grid,
  Paper,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  AdminPanelSettings,
  InfoOutlined,
  LockOutlined,
  Login as LoginIcon,
} from "@mui/icons-material";
import { userLogin } from "../../services/auth";
import { useAuth } from "../../Context/AuthContext";
import logo from "../../Assets/logo.png";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [openAdminDialog, setOpenAdminDialog] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [adminError, setAdminError] = useState("");
  const [adminLoading, setAdminLoading] = useState(false);
  const [openLoginHelpDialog, setOpenLoginHelpDialog] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      const res = await userLogin({ phone, password });

      const user = res?.data?.user;
      const token = res?.data?.token;

      if (!user || !token) {
        throw new Error("Invalid login response");
      }

      login(user, token);
      navigate("/clint", { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "فشل تسجيل الدخول. الرجاء التحقق من بيانات الدخول";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleAdminClick = () => {
    setOpenAdminDialog(true);
    setAdminPassword("");
    setAdminError("");
  };

  const handleAdminClose = () => {
    setOpenAdminDialog(false);
    setAdminPassword("");
    setAdminError("");
  };

  const handleAdminSubmit = () => {
    setAdminLoading(true);
    setAdminError("");

    if (adminPassword === "nuvvy123321") {
      setAdminLoading(false);
      setOpenAdminDialog(false);
      navigate("/background/gate/login");
    } else {
      setAdminError("كلمة المرور (رقم الهاتف) غير صحيحة");
      setAdminLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #102e06 0%, #0a1f03 50%, #1a4d0a 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          width: "300px",
          height: "300px",
          background: "rgba(252, 255, 222, 0.08)",
          borderRadius: "37% 63% 58% 42% / 52% 56% 44% 48%",
          top: "-50px",
          right: "-50px",
          animation: "blob 7s infinite",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          background: "rgba(240, 255, 184, 0.06)",
          borderRadius: "37% 63% 58% 42% / 52% 56% 44% 48%",
          bottom: "-50px",
          left: "-50px",
          animation: "blob 7s infinite 2s",
        },
        "@keyframes blob": {
          "0%, 100%": {
            transform: "translate(0, 0) scale(1)",
          },
          "33%": {
            transform: "translate(30px, -50px) scale(1.1)",
          },
          "66%": {
            transform: "translate(-20px, 50px) scale(0.9)",
          },
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid
          container
          spacing={{ xs: 2.5, md: 4 }}
          alignItems="center"
          justifyContent="center"
          sx={{ direction: "rtl" }}
        >
          {/* Login Card */}
          <Grid item xs={12} sm={9} md={5} lg={4}>
            <Card
              sx={{
                width: "100%",
                maxWidth: 460,
                mx: "auto",
                boxSizing: "border-box",
                borderRadius: 3,
                padding: { xs: 3, sm: 4 },
                boxShadow: "0 18px 48px rgba(0, 0, 0, 0.26)",
                animation: "slideUp 0.6s ease-out",
                "@keyframes slideUp": {
                  from: {
                    opacity: 0,
                    transform: "translateY(30px)",
                  },
                  to: {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              {/* Logo */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 3,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: 126, sm: 140 },
                    height: { xs: 126, sm: 140 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "linear-gradient(145deg, #FFFFF1 0%, #FCFFDE 48%, #E8F6A6 100%)",
                    borderRadius: "50%",
                    padding: "9px",
                    boxShadow: `
                      0 18px 42px rgba(16, 46, 6, 0.18),
                      0 0 46px rgba(252, 255, 222, 0.42),
                      inset 0 3px 8px rgba(255, 255, 255, 0.7),
                      inset 0 -8px 18px rgba(74, 124, 40, 0.12)
                    `,
                    border: "1px solid rgba(255, 255, 255, 0.62)",
                    animation: "pulse 3s ease-in-out infinite",
                    "@keyframes pulse": {
                      "0%, 100%": {
                        boxShadow: `
                          0 18px 42px rgba(16, 46, 6, 0.18),
                          0 0 46px rgba(252, 255, 222, 0.42),
                          inset 0 3px 8px rgba(255, 255, 255, 0.7),
                          inset 0 -8px 18px rgba(74, 124, 40, 0.12)
                        `,
                      },
                      "50%": {
                        boxShadow: `
                          0 20px 48px rgba(16, 46, 6, 0.2),
                          0 0 62px rgba(252, 255, 222, 0.56),
                          inset 0 3px 8px rgba(255, 255, 255, 0.7),
                          inset 0 -8px 18px rgba(74, 124, 40, 0.12)
                        `,
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      overflow: "hidden",
                      backgroundColor: "#3F5044",
                      border: "4px solid rgba(255, 255, 241, 0.9)",
                      boxShadow:
                        "inset 0 0 0 1px rgba(63, 80, 68, 0.18), 0 8px 18px rgba(16, 46, 6, 0.16)",
                    }}
                  >
                    <Box
                      component="img"
                      src={logo}
                      alt="Logo"
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "block",
                        objectFit: "cover",
                        transform: "scale(1.04)",
                        filter: "drop-shadow(0 3px 5px rgba(0, 0, 0, 0.14))",
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Title */}
              <Box sx={{ textAlign: "center", marginBottom: 3 }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    background: "linear-gradient(135deg, #102e06 0%, #4a7c28 100%)",
                    backgroundClip: "text",
                    webkitBackgroundClip: "text",
                    webkitTextFillColor: "transparent",
                    marginBottom: 1,
                  }}
                >
                  مرحباً بك
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#fcffde",
                    fontWeight: 600,
                  }}
                >
                  تسجيل الدخول إلى حسابك
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <Button
                  type="button"
                  size="small"
                  startIcon={<InfoOutlined fontSize="small" />}
                  onClick={() => setOpenLoginHelpDialog(true)}
                  sx={{
                    color: "#2d641a",
                    fontWeight: 800,
                    fontSize: 13,
                    textTransform: "none",
                    px: 1.25,
                    py: 0.5,
                    borderRadius: 1.5,
                    backgroundColor: "rgba(245, 255, 232, 0.78)",
                    border: "1px solid rgba(74, 124, 40, 0.18)",
                    "&:hover": {
                      backgroundColor: "#f5ffe8",
                      borderColor: "rgba(74, 124, 40, 0.32)",
                    },
                  }}
                >
                  ازاي اقدر اعمل تسجيل دخول؟
                </Button>
              </Box>
              {false && (
              <Alert
                severity="info"
                sx={{
                  width: "100%",
                  boxSizing: "border-box",
                  marginBottom: 2,
                  px: 1.5,
                  py: 1.25,
                  borderRadius: 1.5,
                  backgroundColor: "#E3F2FD",
                  color: "#0D47A1",
                  border: "1px solid #64B5F6",
                  alignItems: "flex-start",
                  "& .MuiAlert-icon": {
                    color: "#1976D2",
                    mt: 0.2,
                    mx: 0.5,
                  },
                  "& .MuiAlert-message": {
                    width: "100%",
                    minWidth: 0,
                    overflow: "hidden",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 700, marginBottom: 0.5, fontSize: 13 }}>
                  ⚠️ تنبيه مهم
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    lineHeight: 1.7,
                    fontSize: 12.5,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                  }}
                >
                  يجب عليك التسجيل من خلال فرعنا الرئيسي أولاً قبل تسجيل الدخول، حتى نتمكن من إنشاء حساب لك والتحقق من بيانات الاتصال.
                </Typography>
                <Box sx={{ marginTop: 0.75, paddingTop: 0.75, borderTop: "1px solid #64B5F6" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      marginBottom: 0.5,
                      lineHeight: 1.6,
                      overflowWrap: "anywhere",
                    }}
                  >
                    📍 <strong>الموقع:</strong>  NUVVY، كفر الدوار، البحيرة، شارع الحدايق
                  </Typography>
                  <Typography variant="caption" sx={{ display: "block", lineHeight: 1.6 }}>
                    📞 <strong>هاتفنا:</strong> 01288339973
                  </Typography>
                </Box>
              </Alert>
              )}

              {/* Form */}
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2.5,
                }}
              >
                {/* Phone Input */}
                <TextField
                  label="رقم الهاتف"
                  placeholder="أدخل رقم هاتفك"
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  disabled={loading}
                  required
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">📱</InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1.5,
                      background: "#f5ffe8",
                      transition: "all 0.3s ease",
                      "&:hover fieldset": {
                        borderColor: "#fcffde",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#fcffde",
                        boxShadow: "0 0 0 4px rgba(252, 255, 222, 0.1)",
                      },
                      "&.Mui-disabled": {
                        background: "#f3f4f6",
                        opacity: 0.6,
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      direction: "ltr",
                      color: "#102e06",
                    },
                    "& .MuiInputLabel-root": {
                      color: "#4a7c28",
                      "&.Mui-focused": {
                        color: "#fcffde",
                      },
                    },
                  }}
                />

                {/* Password Input */}
                <TextField
                  label="كلمة المرور (رقم الهاتف)"
                  placeholder="أدخل كلمة المرور (رقم الهاتف)"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  required
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          disabled={loading}
                          edge="end"
                          sx={{ padding: 1 }}
                        >
                          {showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1.5,
                      background: "#f5ffe8",
                      transition: "all 0.3s ease",
                      "&:hover fieldset": {
                        borderColor: "#fcffde",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#fcffde",
                        boxShadow: "0 0 0 4px rgba(252, 255, 222, 0.1)",
                      },
                      "&.Mui-disabled": {
                        background: "#f3f4f6",
                        opacity: 0.6,
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      direction: "ltr",
                      color: "#102e06",
                    },
                    "& .MuiInputLabel-root": {
                      color: "#4a7c28",
                      "&.Mui-focused": {
                        color: "#fcffde",
                      },
                    },
                  }}
                />

                {/* Error Message */}
                {error && (
                  <Alert
                    severity="error"
                    sx={{
                      borderRadius: 1.5,
                      animation: "shake 0.4s ease",
                      "@keyframes shake": {
                        "0%, 100%": {
                          transform: "translateX(0)",
                        },
                        "25%": {
                          transform: "translateX(-5px)",
                        },
                        "75%": {
                          transform: "translateX(5px)",
                        },
                      },
                    }}
                  >
                    {error}
                  </Alert>
                )}

                {/* Submit Button */}
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={loading}
                  fullWidth
                  startIcon={!loading ? <LoginIcon /> : null}
                  sx={{
                    background: "linear-gradient(135deg, #14520b 0%, #2f7d1d 100%)",
                    padding: "14px",
                    fontSize: 17,
                    fontWeight: 900,
                    textTransform: "none",
                    letterSpacing: 0,
                    borderRadius: 1.5,
                    color: "#ffffff",
                    border: "1px solid rgba(252, 255, 222, 0.72)",
                    boxShadow: "0 10px 24px rgba(20, 82, 11, 0.32)",
                    transition: "all 0.3s ease",
                    marginTop: 1,
                    "& .MuiButton-startIcon": {
                      ml: 1,
                      mr: 0,
                    },
                    "&:hover:not(:disabled)": {
                      background: "linear-gradient(135deg, #0f4208 0%, #256916 100%)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 14px 30px rgba(20, 82, 11, 0.42)",
                    },
                    "&:disabled": {
                      opacity: 0.7,
                    },
                  }}
                >
                  {loading ? "جاري التحميل..." : "دخول"}
                </Button>
              </Box>

              {/* Divider */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  margin: "25px 0",
                  color: "#ccc",
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    height: "1px",
                    background: "#e8f5d9",
                  }}
                />
                <Typography sx={{ color: "#fcffde", fontSize: 13 }}>
                  أو
                </Typography>
                <Box
                  sx={{
                    flex: 1,
                    height: "1px",
                    background: "#e8f5d9",
                  }}
                />
              </Box>

              {/* Footer */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                  marginTop: 2,
                }}
              >
                <IconButton
                  size="medium"
                  onClick={handleAdminClick}
                  aria-label="لوحة التحكم"
                  title="لوحة التحكم"
                  sx={{
                    width: 44,
                    height: 44,
                    background: "linear-gradient(135deg, #102e06 0%, #1a4d0a 100%)",
                    color: "#fcffde",
                    border: "1px solid rgba(252, 255, 222, 0.85)",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(252, 255, 222, 0.2)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #0a1f03 0%, #102e06 100%)",
                      color: "#f0ffb8",
                      boxShadow: "0 8px 24px rgba(252, 255, 222, 0.4)",
                      transform: "translateY(-2px)",
                      borderColor: "#f0ffb8",
                    },
                  }}
                >
                  <LockOutlined />
                </IconButton>
              </Box>
            </Card>
          </Grid>

          {/* Info Cards (Desktop) */}
          <Grid item xs={0} md={5} sx={{ display: { xs: "none", md: "block" } }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
                animation: "slideUpDelay 0.8s ease-out",
                "@keyframes slideUpDelay": {
                  from: {
                    opacity: 0,
                    transform: "translateY(30px)",
                  },
                  to: {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              {/* Info Card 1 */}
              <Paper
                sx={{
                  background: "rgba(252, 255, 222, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(252, 255, 222, 0.3)",
                  borderRadius: 2,
                  padding: 3,
                  color: "#f5ffe8",
                  boxShadow: "0 8px 32px rgba(252, 255, 222, 0.2)",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  🎯 انشئ مشروبك بنفسك
                </Typography>
                <Typography sx={{ fontSize: 14, opacity: 0.95, lineHeight: 1.5 }}>
                  استمتع بتجربة انشاء المشروبات الذكية 
                </Typography>
              </Paper>

              {/* Info Card 2 */}
              <Paper
                sx={{
                  background: "rgba(252, 255, 222, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(252, 255, 222, 0.3)",
                  borderRadius: 2,
                  padding: 3,
                  color: "#f5ffe8",
                  boxShadow: "0 8px 32px rgba(252, 255, 222, 0.2)",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  ⚡ اول مرة في مصر 
                </Typography>
                <Typography sx={{ fontSize: 14, opacity: 0.95, lineHeight: 1.5 }}>
                 تجربة قوية لانشاء مشروب مخصص لكل ومشاركته مع اصدقائك
                </Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Dialog
        open={openLoginHelpDialog}
        onClose={() => setOpenLoginHelpDialog(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            direction: "rtl",
            borderRadius: 3,
            overflow: "hidden",
            background: "linear-gradient(180deg, #ffffff 0%, #f7ffe9 100%)",
            boxShadow: "0 24px 70px rgba(16, 46, 6, 0.28)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#102e06",
            fontWeight: 900,
            fontSize: 18,
            pb: 1,
          }}
        >
          <InfoOutlined sx={{ color: "#4a7c28" }} />
          ازاي اقدر اعمل تسجيل دخول؟
        </DialogTitle>
        <DialogContent
          sx={{
            color: "#27441d",
            pt: 1,
            "& .MuiTypography-root": {
              lineHeight: 1.8,
            },
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
            يجب إنشاء حسابك أولًا من شاشة الطلبات في الفرع الرئيسي قبل تسجيل الدخول.
          </Typography>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              backgroundColor: "rgba(74, 124, 40, 0.08)",
              border: "1px solid rgba(74, 124, 40, 0.16)",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 800 }}>
              الموقع: NUVVY، كفر الدوار، البحيرة، شارع الحدائق
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.75, fontWeight: 800, direction: "ltr", textAlign: "right" }}>
              01288339973
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ display: "block", mt: 1.5, color: "#5f7754" }}>
            بعد إنشاء الحساب يمكنك الدخول برقم الهاتف وكلمة المرور الخاصة بك.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button
            onClick={() => setOpenLoginHelpDialog(false)}
            variant="contained"
            fullWidth
            sx={{
              borderRadius: 1.5,
              py: 1,
              color: "#102e06",
              fontWeight: 900,
              background: "linear-gradient(135deg, #fcffde 0%, #e7fba6 100%)",
              boxShadow: "none",
              "&:hover": {
                background: "linear-gradient(135deg, #f5ffd1 0%, #dff58e 100%)",
                boxShadow: "0 8px 20px rgba(74, 124, 40, 0.18)",
              },
            }}
          >
            فهمت
          </Button>
        </DialogActions>
      </Dialog>

      {/* Admin Password Dialog */}
      <Dialog
        open={openAdminDialog}
        onClose={handleAdminClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
            background: "linear-gradient(135deg, #f5ffe8 0%, #e8f5d9 100%)",
            backdropFilter: "blur(10px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            color: "#102e06",
            fontSize: 20,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <AdminPanelSettings sx={{ color: "#fcffde" }} />
          لوحة تحكم الأدمن
        </DialogTitle>
        <DialogContent sx={{ minWidth: 350 }}>
          <Box sx={{ pt: 2 }}>
            <TextField
              fullWidth
              label="كلمة المرور (رقم الهاتف)"
              type="password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              disabled={adminLoading}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleAdminSubmit();
                }
              }}
              autoFocus
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                  background: "#FFF9F0",
                  "& fieldset": {
                    borderColor: "#fcffde",
                  },
                  "&:hover fieldset": {
                    borderColor: "#f0ffb8",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#fcffde",
                    boxShadow: "0 0 0 4px rgba(252, 255, 222, 0.1)",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#4a7c28",
                  "&.Mui-focused": {
                    color: "#fcffde",
                  },
                },
              }}
            />
            {adminError && (
              <Alert
                severity="error"
                sx={{
                  mt: 2,
                  borderRadius: 1.5,
                  backgroundColor: "#FFE5E5",
                  color: "#C33",
                  border: "1px solid #FCC",
                }}
              >
                {adminError}
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleAdminClose}
            disabled={adminLoading}
            sx={{
              color: "#4a7c28",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: "rgba(252, 255, 222, 0.1)",
              },
            }}
          >
            إلغاء
          </Button>
          <Button
            onClick={handleAdminSubmit}
            loading={adminLoading}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #fcffde 0%, #f0ffb8 100%)",
              color: "#102e06",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: 1,
              boxShadow: "0 4px 15px rgba(252, 255, 222, 0.4)",
              "&:hover": {
                boxShadow: "0 8px 25px rgba(252, 255, 222, 0.6)",
                transform: "translateY(-2px)",
              },
              "&:disabled": {
                opacity: 0.7,
              },
            }}
          >
            {adminLoading ? "جاري التحقق..." : "دخول"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
